import { Popover } from '@mui/material';
import { reactionEmoji } from '../lib/reactionEmoji';
import { reactionPickerRows } from '../lib/reactionPickerRows';
import { ReactionType } from '../model/post.types';

type Props = {
  open: boolean;
  anchorEl: HTMLElement | null;
  onClose: () => void;
  onSelect: (type: ReactionType) => void;
};

export const AddReactionPopover = ({
  open,
  anchorEl,
  onClose,
  onSelect,
}: Props) => (
  <Popover
    open={open}
    anchorEl={anchorEl}
    onClose={onClose}
    anchorOrigin={{ vertical: 'top', horizontal: 'left' }}
    transformOrigin={{ vertical: 'bottom', horizontal: 'left' }}
  >
    <div className="flex flex-col gap-5 p-5">
      {reactionPickerRows.map((row, index) => (
        <div key={index} className="flex flex-row gap-2.5">
          {row.map((type) => (
            <button
              key={type}
              type="button"
              aria-label={type}
              onClick={() => onSelect(type)}
              className="size-10 rounded-full bg-[#F4F1FB] text-xl leading-10"
            >
              {reactionEmoji(type)}
            </button>
          ))}
        </div>
      ))}
    </div>
  </Popover>
);
